import * as React from 'react'
// import Plotly from 'plotly.js-dist'
import ApexCharts from 'apexcharts'


export default ResultsPage = (props) => {

    React.useEffect(() => {

        let dateMin = new Date(2020, 0, 1)
        let dateMax = new Date(2020, 11, 31)
        let dateLen = 64
        const x = generateDates(dateLen, dateMin, dateMax)
        const y = generateChromatogram(dateLen, 0.5, 100000, 27000);
        console.log(x, y)
        const sliceMin = 14
        const sliceMax = 50
        const x1 = x.slice(sliceMin, sliceMax+1)
        let model = findGradientAndB([x[sliceMin], y[sliceMin]], [x[sliceMax], y[sliceMax]])
        let y1 = []
        for (let i=0; i<x1.length; i++) {
            y1.push(findY(x1[i], model.m, model.b))
        }
        
        // let trace1 = {
        //     x: x1,
        //     y: y1,
        //     // fill: 'tonexty',
        //     type: 'scatter',
        //     mode: 'lines+markers',
        // };
          
        // let trace2 = {
        //     x: x,
        //     y: y,
        //     fill: 'tonexty',
        //     type: 'scatter',
        //     mode: 'lines+markers',
        // };
        
        // let data = [trace1, trace2];
        
        // Plotly.newPlot('myDiv', data);

        let data = []
        x.forEach((X, i) => {
            data.push({
                x: X,
                y: [y[i], y1[i]]
            })
        })
        
 
        var options = {
            series: {
                name: 'Temperature',
                data: data
            },
            chart: {
                height: 350,
                type: 'rangeArea'
            },
            stroke: {
                curve: 'straight'
            },
            title: {
                text: 'New York Temperature (all year round)'
            },
            markers: {
                hover: {
                    sizeOffset: 5
                }
            },
            dataLabels: {
                enabled: false
            },
            yaxis: {
                labels: {
                    formatter: (val) => {
                        return val + '°C'
                    }
                }
            }
            };
    
            var chart = new ApexCharts(document.querySelector("#myDiv"), options);
            chart.render();
            

    }, [])

    return (
        
        <div>
            <script src="https://cdn.plot.ly/plotly-2.29.1.min.js" charset="utf-8"></script>
            <h1>Results Page</h1>
            <p>Results go here</p>
        
            <div id="myDiv"></div>
        
        </div>
    )
}


function generateDates(len, dateMin, dateMax) {
    let dates = [];
    let start = new Date(dateMin);
    let end = new Date(dateMax);
    let diffTime = Math.abs(end - start);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    let step = Math.floor(diffDays / len);

    for(let i = 0; i < len; i++) {
        let newDate = new Date(start.getTime() + i * step * 24 * 60 * 60 * 1000);
        dates.push(newDate);
    }

    return dates;
}

function findGradientAndB(point1, point2) {
    let gradient = (point2[1] - point1[1]) / (point2[0] - point1[0]);
    let b = point1[1] - gradient * point1[0];
    return {
        m: gradient,
        b: b
    }
}

function findY(x, m, b) {
    return m * x + b;
}

function randomNum(len, max) {
    let nums = [];
    for(let i = 0; i < len; i++) {
        nums.push(Math.floor(Math.random() * max));
    }
    return nums;
}

function generateChromatogram(len, peakPosition, peakHeight, noiseLevel) {
    let y = [];
    for(let i = 0; i < len; i++) {
        let x = i / len;
        let peak = peakHeight * Math.exp(-50 * Math.pow((x - peakPosition), 2));
        let noise = (Math.random() - 0.5) * noiseLevel;
        let value = peak + noise;
        y.push(value < 0 ? 0 : value);
    }
    return y;
}